import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import React, {useState} from 'react'
import {IUsers, UsersInitValues as initialValues} from '../../models/UsersModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useIntl} from 'react-intl'
import HeaderCard from '../../../../../../components/Forms/HeaderCard'
import {Input} from '../../../../../../components/Forms/Input'
import {browserName} from 'react-device-detect'
//import {KTSVG} from '../../../../../../_metronic/helpers'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../../../../../../components/Forms/Select/data'
import { Toolbar2 } from '../../../../../../_metronic/layout/components/toolbar/Toolbar2'
import { PageTitle } from '../../../../../../_metronic/layout/core'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

const API_URL = process.env.REACT_APP_API_URL || 'api'

const UsersSchema = Yup.object().shape({
  username: Yup.string().required('Campo obrigatório'),
  firstname: Yup.string().required('Campo obrigatório'),
  lastname: Yup.string().required('Campo obrigatório'),
  email: Yup.string().required('Campo obrigatório'),
  password: Yup.string().required('Campo obrigatório'),
  // .matches(
  //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})/,
  //   'Deve conter 8 caracteres, um maiúsculo, um minúsculo, um número e um caractere especial'
  // ),
  confirm_password: Yup.string()
    .required()
    .oneOf([Yup.ref('password'), null], 'Senhas não conferem'),
  // active: Yup.boolean().required('Campo obrigatório'),
  // device_name: Yup.string().required('Campo obrigatório'),
})

const FormUsersAdd: React.FC = () => {
  // eslint-disable-next-line
  const [uuid, setUuid] = useState('')
  // console.log('NAVEGADOR', browserName)
  const intl = useIntl()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [roleID, setRoleID] = useState('')
  const resp = localStorage.getItem('auth_storage')
  let token = ''
  if (resp) {
    token = JSON.parse(resp)
  }
  let config = {
    headers: {
      Authorization: 'Bearer ' + token,
    },
  }

  //INICIO SUBMIT FORM
  const formik = useFormik<IUsers>({
    initialValues,
    validationSchema: UsersSchema,
    onSubmit: async (values) => {
      //recebe o nome do navegador
      values.device_name = browserName

      //busca as permissoes do roles
      let {data} = await axios.get(API_URL + '/v1/roles/' + roleID, config)
      let total = data.data.permissions as any[]
      let permissionsArray = [] as any

      for (let i = 0; i < total.length; i++) {
        permissionsArray.push(data.data.permissions[i].id)
      }
      //recebe as permissoes do roles
      values.permissions = permissionsArray

      setLoading(true)
      try {
        await axios.post(API_URL + '/v1/register' + uuid, values, config)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'USERS.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/users')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'USERS.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })

        setLoading(false)
      }
    },
  })
  function resetInputs() {
    formik.resetForm()
  }
  // Carregar os dados do select
  const loadOptions = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getUser()
      var units: any = []
      async function getUser() {
        const {data} = await axios.get(API_URL + '/v1/roles/select2')
        let Response = data.results

        for (var i = 0; i < Response.length; i++) {
          const unit: any = {
            value: Response[i].id,
            label: Response[i].name,
          }

          units.push(unit)
        }
      }
      callback(units)
    }, 1000)
  }

  // Insere os dados do select
  const handleInputChange = (event: any) => {
    var inputValue = ''
    inputValue = event.value
    formik.setFieldValue('roles', [inputValue])
    setRoleID(inputValue)
    return {inputValue}
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}

      <Toolbar2 icon={false} subtitle={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})} />
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'USERS.NEW_USER'})}</PageTitle>

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO USERNAME */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_USERNAME'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_USERNAME'})}
              {...formik.getFieldProps('username')}
              required
            />
            {/* FIM USERNAME */}

            {/* INICIO FIRSTNAME */}

            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
              {...formik.getFieldProps('firstname')}
              required
            />
            {/* FIM FIRSTNAME */}

            {/* INICIO LASTNAME */}
            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_SURNAME'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_SURNAME'})}
              {...formik.getFieldProps('lastname')}
              required
            />

            {/* FIM LASTNAME */}

            {/* INICIO EMAIL */}
            <Input
              title={intl.formatMessage({id: 'USERS.INPUT_EMAIL'})}
              placeholder={intl.formatMessage({id: 'USERS.INPUT_EMAIL'})}
              {...formik.getFieldProps('email')}
              required
            />
            {/* FIM EMAIL */}

            {/* INICIO PASSWORD */}
            <Input
              title={intl.formatMessage({id: 'AUTH.INPUT.PASSWORD'})}
              type='password'
              placeholder={intl.formatMessage({id: 'AUTH.INPUT.PASSWORD'})}
              {...formik.getFieldProps('password')}
              required
            />
            {/* FIM PASSWORD */}

            {/* INICIO CONFIRM_PASSWORD */}
            <Input
              title={intl.formatMessage({id: 'AUTH.INPUT.CONFIRM_PASSWORD'})}
              type='password'
              placeholder={intl.formatMessage({id: 'AUTH.INPUT.CONFIRM_PASSWORD'})}
              {...formik.getFieldProps('confirm_password')}
              required
            />
            {formik.touched.confirm_password && formik.errors.confirm_password && (
              <div className='fv-plugins-message-container text-danger'>
                <div className='fv-help-block'>{formik.errors.confirm_password}</div>
              </div>
            )}
            {/* FIM CONFIRM_PASSWORD */}

            {/* INICIO ACTIVE */}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label required fw-bold'>
                {intl.formatMessage({id: 'COMMON.ACTIVE_USER'})}
              </label>

              <div className='col-lg-10 fv-row'>
                <select
                  className='form-select form-select-solid fw-bold'
                  {...formik.getFieldProps('active')}
                >
                  <option value='true' selected>
                    {intl.formatMessage({id: 'COMMON.ACTIVE_USER'})}
                  </option>
                  <option value='false'>{intl.formatMessage({id: 'USERS.DISABLED'})}</option>
                </select>
              </div>
            </div>
            {/* FIM ACTIVE */}

            {/* INICIO ROLES */}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label required fw-bold'>
                Tipo de usuário
              </label>

              <div className='col-lg-10 fv-row'>
                <AsyncSelect
                  className='form-control form-control-solid p-1 pl-1 fw-bold'
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                  }
                  onChange={handleInputChange}
                  placeholder='Selecione o tipo de usuário'
                  styles={colourStyles}
                />
              </div>
            </div>
            {/* FIM ROLES */}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-sm btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-sm btn-secondary  mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormUsersAdd}
